<template>
  <b-form>
    <div class="row mb-3 border-bottom g-0">
      <div class="col-12">
        <span class="fw-bold">Berita Acara</span>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6 mt-3">
        <label>Masa Berlaku <span class="text-danger">*</span></label>
        <v-select
          v-model="jenis_masa_berlaku"
          id="masa_berlaku"
          :options="['Diketahui', 'Lain-Lain']"
          name="Masa Berlaku"
          v-validate="'required'"
        />
        <div class="mt-2">
          <template v-if="jenis_masa_berlaku === 'Diketahui'">
            <b-form-input
              type="date"
              v-model="form.masa_berlaku"
              id="masa_berlaku"
              v-validate="'required'"
              name="Masa Berlaku"
            ></b-form-input>
          </template>
          <template v-else-if="jenis_masa_berlaku === 'Lain-Lain'">
            <b-form-input
              v-model="form.masa_berlaku"
              id="masa_berlaku"
              v-validate="'required'"
              name="Masa Berlaku"
            ></b-form-input>
          </template>
        </div>
        <!-- <span class="text-danger" v-if="errors.has('Masa Berlaku')">
          {{ errors.first('Masa Berlaku') }}
        </span> -->
      </div>
      <div class="w-100"></div>
      <div class="col-lg-6 mt-3">
        <label>Nomor Surat Penyampaian Tahunan <span class="text-danger">*</span></label>
        <b-form-input
          v-model="form.nomor_surat_penyampaian_tahunan"
          name="Nomor Surat Penyampaian Tahunan"
          id="nomor_surat_penyampaian_tahunan"
          style="background-color: white"
        ></b-form-input>
      </div>
      <div class="w-100"></div>
      <div class="col-lg-6 mt-3">
        <label>Nama Perwakilan <span class="text-danger">*</span></label>
        <b-form-input
          v-model="form.nama_perwakilan"
          name="Nama Perwakilan"
          id="nama_perwakilan"
          style="background-color: white"
        ></b-form-input>
      </div>
      <div class="w-100"></div>
      <div class="col-lg-6 mt-3">
        <label>Tanggal Berita Acara <span class="text-danger">*</span></label>
        <b-form-input
          type="date"
          v-model="form.tanggal_berita_acara"
          name="Tanggal Berita Acara"
          id="tanggal_berita_acara"
          style="background-color: white"
        ></b-form-input>
      </div>
    </div>
    <div class="mt-5 fw-bold">Note: tanda (<span class="text-danger">*</span>) wajib diisi</div>
  </b-form>
</template>

<script>
import vSelect from 'vue-select'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

export default {
  components: { vSelect },
  data() {
    return {
      jenis_masa_berlaku: null,
      form: {
        masa_berlaku: '',
        nomor_surat_penyampaian_tahunan: '',
        nama_perwakilan: '',
        tanggal_berita_acara: '',
      },
      wygEditor: ClassicEditor,
    }
  },
  methods: {
    nextForm() {
      return true
    },
  },
}
</script>
